import {AltaPayFactory} from "./AltaPayFactory.js";
import {Browser} from "./Browser.js";

/**
 * @class BrowserService
 * @description Collect information about the browser.
 */
class BrowserService {

    altaPayFactory;

    constructor() {
        this.altaPayFactory = new AltaPayFactory();
    }

    /**
     * @method getBrowser
     * @description Gets browser information.
     * @returns {Promise<Browser>}
     */
    async getBrowser() {
        // we need to make sure we capture the top window origin and not the embedded iframe otherwise we're vetting for legitimacy of the parent website with our domain!
        // Thankfully ApplePay is not working because of it, but potentially more payment methods could be blocked because of different origin than expected.
        let origin = window.location.origin;
        if (this.#loadedInIframe()) {
            const originOverride = this.#getParam("origin");
            if (originOverride) {
                origin = originOverride;
            } else {
                throw new Error('AltaPay library is loaded inside iframe without specifying "origin" parameter. Please refer to documentation for more information!');
            }
        }

        return this.altaPayFactory.getBrowser(navigator.userAgent, navigator.language, origin, screen.height, screen.width);
    }

    #loadedInIframe() {
        return window.top !== window.self;
    }

    #getParam(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }
}

export {BrowserService};
